import React from 'react';
import ModuloTemplate from '../Elements/ModuloTemplate';

const bnrimg = require('../../images/pic1.jpg');
const productImg = require('../../images/Plan_de_obra.png');

const WorkModule = () => (
    <ModuloTemplate
        moduleKey="obra"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default WorkModule;
